export function centavos(value) {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 0 || value > 1000000) throw new Error('Importe inválido.');
  return Math.round((value + Number.EPSILON) * 100);
}

export function importeCentavos(value) {
  if (!Number.isSafeInteger(value) || value < 0 || value > 100000000) throw new Error('Importe en centavos inválido.');
  return value;
}

// Solo presentación: un combo puede dividirse entre un número de entradas que
// no produzca centavos unitarios enteros. Nunca persistir este cociente.
export function consumoDelPaquete(paquete) {
  if (paquete.consumoCentavos === undefined) return null;
  const consumo = importeCentavos(paquete.consumoCentavos);
  if (consumo > importeCentavos(paquete.precioCentavos)) throw new Error('El consumo no puede superar el precio del paquete.');
  if (paquete.cantidadEntradas === 0 && consumo !== paquete.precioCentavos) throw new Error('Un paquete sin entradas debe asignar todo su precio al consumo.');
  return consumo;
}

export function consumoAutomaticoPaquete(precioCentavos, cantidadEntradas) {
  importeCentavos(precioCentavos);
  if (!Number.isSafeInteger(cantidadEntradas) || cantidadEntradas < 0) throw new Error('Cantidad de entradas inválida.');
  const consumo = precioCentavos - cantidadEntradas * 5000;
  if (consumo < 0) throw new Error('El precio no cubre 50 Bs por entrada. Indica un consumo explícito válido.');
  return consumo;
}

export function grupoEconomicoEntrada(entrada, reserva) {
  if (!reserva || (reserva.id && entrada.reservaId !== reserva.id) ||
      (entrada.eventoId && entrada.eventoId !== reserva.eventoId) ||
      (entrada.empresaId && entrada.empresaId !== reserva.empresaId)) return null;
  if (reserva.emisionVersion === 2) {
    const g = reserva.gruposEmision?.find(g => entrada.indiceEntrada >= g.inicio && entrada.indiceEntrada < g.inicio + g.cantidad)?.datos;
    return g && Number.isSafeInteger(g.precioComboCentavos) && g.entradasEnCombo > 0 ? {precioComboCentavos:g.precioComboCentavos,entradasEnCombo:g.entradasEnCombo} : null;
  }
  if (entrada.tipoEntrada === 'paquete') {
    const consumo = reserva.consumoCentavos;
    if (!Number.isSafeInteger(consumo) || consumo < 0 || !Number.isSafeInteger(reserva.montoCentavos) || consumo > reserva.montoCentavos) return null;
    return { precioComboCentavos: reserva.montoCentavos - consumo, entradasEnCombo: reserva.cantidadEntradas };
  }
  if (entrada.tipoEntrada === 'extra') {
    const extra = reserva.extras?.[entrada.extraIndice];
    if (!extra || extra.productoId !== entrada.comboId) return null;
    return { precioComboCentavos: extra.precioCentavos, entradasEnCombo: extra.entradasPorUnidad };
  }
  return null;
}

export function precioEntradaParaMostrar(entrada, reserva) {
  if (entrada.reservaId && reserva) {
    const grupo = grupoEconomicoEntrada(entrada, reserva);
    return grupo ? precioEntradaParaMostrar(grupo) : null;
  }
  if (entrada.precioComboCentavos !== undefined && entrada.entradasEnCombo > 0) return entrada.precioComboCentavos / entrada.entradasEnCombo / 100;
  if (entrada.precioUnitarioCentavos !== undefined) return entrada.precioUnitarioCentavos / 100;
  return null;
}

export function resumenPreciosEntradas(entradas, reservas = {}) {
  let total = 0, sinPrecio = 0;
  entradas.filter(e=>e.estado!=='anulada').forEach((entrada) => {
    const precio = precioEntradaParaMostrar(entrada, reservas[entrada.reservaId]);
    if (precio === null) sinPrecio++; else total += precio;
  });
  return { totalBs: sinPrecio === entradas.filter(e=>e.estado!=='anulada').length && sinPrecio > 0 ? null : Number(total.toFixed(2)), sinPrecio };
}
